import _ from 'lodash';
import types from "./actionTypes";
import LoaderActions from "./loaderActions";
import Vehicle from "../../services/vehicle";
import CONSTANTS from "../../common/constants";

class VehicleActions {
    static searchByVin(vin) {
        return async function (dispatch, getState) {
            dispatch(LoaderActions.startAsyncCall());
            try {
                const vehicle = await Vehicle.searchByVin(vin);
                dispatch(VehicleActions._setVehicle(vehicle));
            } catch (error) {
                if (error.status === CONSTANTS.STATUS_CODE.NOT_FOUND) {
                    dispatch(VehicleActions._setVehicle({}));
                }
                dispatch(LoaderActions.errorAsyncCall());
                throw error;
            }
        };
    }

    static searchByDevice(device) {
        return async function (dispatch, getState) {
            dispatch(LoaderActions.startAsyncCall());
            try {
                const result = await Vehicle.searchByDevice(device);
                const vehicle = await Vehicle.searchByVin(_.get(result, `vin`));
                dispatch(VehicleActions._setVehicle(vehicle));
            } catch (error) {
                if (error.status === CONSTANTS.STATUS_CODE.NOT_FOUND) {
                    dispatch(VehicleActions._setVehicle({}));
                }
                dispatch(LoaderActions.errorAsyncCall());
                throw error;
            }
        };
    }

    static deleteDevice() {
        return {
            type: types.VEHICLE.DELETE_DEVICE
        };
    }

    static _setVehicle(vehicle) {
        return {
            type: types.VEHICLE.SET,
            vehicle
        };
    }
}
export default VehicleActions;
